<template>
  <div>
    <v-skeleton-loader
      type="table-thead, table-tbody"
      width="100%"
      :loading="tableLoading"
      class="pa-4"
      boilerplate
    >
      <v-container class="prices-list-table pa-0 fill-height" fluid>
        <v-card width="100%" class="fill-height" color="gray10 pa-5">
          <v-row class="fill-height">
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <h1 class="gray1--text font-Regular-24 text-start">
                    {{ $t("withdraw.excoinoTransfer") }}
                  </h1>
                </v-col>
                <v-col cols="12" md="6">
                  <withdraw-form @getList="getList" />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-start text-light">
                    <p class="font-Medium-14 mb-8">{{ $t("common.tip") }}</p>
                    <div class="font-Regular-12">
                      <p class="mb-4">• {{ $t("withdraw.warning4") }}</p>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <!--Table -->
              <withdraw-table
                :items="tableWithdraw"
                :paginate="tablePaginate"
                @changePage="changePage"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-skeleton-loader>
  </div>
</template>
<script>
import { UserCenterService } from "@/services";
import WithdrawForm from "@/components/Market/withdraw/withdrawForm.vue";
import WithdrawTable from "@/components/Market/withdraw/withdrawTable.vue";

export default {
  name: "index",
  components: { WithdrawTable, WithdrawForm },
  data() {
    return {
      tableLoading: true,
      tableWithdraw: [],
      tablePaginate: {
        page: 1,
        pageSize: 10,
        total: 1
      }
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      //get table withdraw
      let payload = {
        page: this.tablePaginate.page - 1,
        pageSize: this.tablePaginate.pageSize
      };
      UserCenterService.getWithdrawRecords(payload)
        .then(response => {
          if (response.data.code === 0) {
            this.tableWithdraw = response.data.data.content;
            this.tablePaginate.total = response.data.data.totalPages - 1;
            this.tablePaginate.page = response.data.data.number + 1;
          }
        })
        .catch(err => {
          this.$toast.error(err.message);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePage(data) {
      this.tablePaginate.page = data;
      this.getList();
    }
  }
};
</script>
<style scoped lang="scss"></style>
